import script from "./MenuBottom.vue?vue&type=script&lang=ts&setup=true"
export * from "./MenuBottom.vue?vue&type=script&lang=ts&setup=true"

import "./MenuBottom.vue?vue&type=style&index=0&id=085da17a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-085da17a"]])

export default __exports__